import React from 'react';

import CopyableField from './CopyableField';

type Props = {
  userId: string;
  label: string;
};

function CopyableUserLink({ userId, label }: Props) {
  return (
    <CopyableField value={userId} label=" ">
      <a href={`/users/${userId}`}>{label}</a>
    </CopyableField>
  );
}

export default CopyableUserLink;
